import { useRef } from 'react'

import { useUnsafeEffect } from './useEffect'

export function usePrevious<T>(value: T) {
  const ref = useRef<T>()
  useUnsafeEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}
